"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLeadBidValidationSchema = exports.UpdateProgramPriceSettingsValidationSchema = exports.UpdateSupportTicketValidationSchema = exports.CreateSupportTicketMessageValidationSchema = exports.CreateSupportTicketValidationSchema = exports.UpdateAccountValidationSchema = exports.CreateAccountValidationSchema = exports.DenyBidValidationSchema = exports.CreateBidValidationSchema = exports.CreateCardValidationSchema = exports.UpdateOrderValidationSchema = exports.CreateOrderValidationSchema = exports.UpdatePaymentValidationSchema = exports.CustomerSignInValidationSchema = exports.SignInValidationSchema = exports.SignUpValidationSchema = exports.UpdatePasswordSchema = exports.ForgotPasswordSchema = exports.UpdateProfileSchema = exports.UpdateUserBankingDetailsSchema = exports.CreateCustomerSchema = exports.CPF_TEST = exports.CNPJ_TEST = void 0;
const moment_1 = __importDefault(require("moment"));
const lodash_1 = require("lodash");
const Yup = __importStar(require("yup"));
function CNPJ_TEST(value) {
    const cnpj = value.replace(/[^\d]+/g, '');
    if (cnpj == '') {
        return false;
    }
    if (cnpj.length != 14) {
        return false;
    }
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999") {
        return false;
    }
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        return false;
    }
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
        return false;
    }
    return true;
}
exports.CNPJ_TEST = CNPJ_TEST;
function CPF_TEST(value) {
    const cpf = (value === null || value === void 0 ? void 0 : value.replace(/[^\d]+/g, '')) || '';
    if (cpf == '') {
        return false;
    }
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999")
        return false;
    let add = 0;
    for (let i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(9)))
        return false;
    add = 0;
    for (let i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
        rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
        return false;
    return true;
}
exports.CPF_TEST = CPF_TEST;
const REQUIRED_FIELD = 'Este campo é obrigatório';
const MUST_BE_VALID_EMAIL = 'Este campo deve ser um e-mail válido';
const MUST_BE_VALID_CPF = 'Este campo deve ser um CPF válido';
const MUST_BE_GREATER_THAN_ZERO = 'Deve ser maior que zero';
exports.CreateCustomerSchema = Yup.object({
    name: Yup.string().required(REQUIRED_FIELD),
    phone_number: Yup.string().required(REQUIRED_FIELD),
    address_cep: Yup.string().test({
        message: 'Deve ser um CEP válido',
        test: (value) => {
            const cep = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (cep === null || cep === void 0 ? void 0 : cep.length) === 8;
        }
    }).required(REQUIRED_FIELD),
    address_street: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    address_neighborhood: Yup.string().required(REQUIRED_FIELD),
    address_complement: Yup.string().optional(),
    address_city: Yup.string().required(REQUIRED_FIELD),
    address_state: Yup.string().length(2, 'Use apenas a sigla do estado (Ex.: SP, RJ, SC)').required(REQUIRED_FIELD),
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    document_number: Yup.string().when('is_business', {
        is: (is_business) => !!is_business,
        then: schema => schema.test({ message: 'Deve ser um documento válido', test: CNPJ_TEST }),
        otherwise: schema => schema.test({ message: 'Deve ser um documento válido', test: CPF_TEST }),
    }).required(REQUIRED_FIELD),
    is_business: Yup.boolean().required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
});
exports.UpdateUserBankingDetailsSchema = Yup.object({
    pix_type: Yup
        .string()
        .oneOf(['EMAIL', 'PHONE_NUMBER', 'CPF', 'RANDOM_KEY', 'CNPJ'])
        .required(REQUIRED_FIELD),
    pix_key: Yup.string().when('pix_type', ([pix_type], schema) => {
        if (pix_type === 'CPF') {
            return schema.test({
                test: CPF_TEST,
                message: 'Deve ser um CPF válido',
            });
        }
        if (pix_type === 'CNPJ') {
            return schema.test({
                test: CNPJ_TEST,
                message: 'Deve ser um CNPJ válido',
            });
        }
        if (pix_type === 'EMAIL') {
            return schema.email('Deve ser um e-mail válido');
        }
        if (pix_type === 'RANDOM_KEY') {
            return schema.length(32, 'Deve conter 32 caracteres');
        }
        if (pix_type === 'PHONE_NUMBER') {
            return schema.test({
                test: (value) => {
                    const clean = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
                    if ((clean === null || clean === void 0 ? void 0 : clean.length) === 13) {
                        return true;
                    }
                    return false;
                },
                message: 'Deve conter 9 números'
            });
        }
        return schema;
    })
        .required(REQUIRED_FIELD),
});
exports.UpdateProfileSchema = Yup.object({
    telegram: Yup.string(),
    cep: Yup.string().test({
        message: 'Deve ser um CEP válido',
        test: (value) => {
            const cep = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (cep === null || cep === void 0 ? void 0 : cep.length) === 8;
        }
    }).required(REQUIRED_FIELD),
    address_street: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    phone_number: Yup.string().required(REQUIRED_FIELD),
    whatsapp: Yup.string().required(REQUIRED_FIELD),
    complement: Yup.string().optional(),
    city: Yup.string().required(REQUIRED_FIELD),
    state: Yup.string().length(2, 'Use apenas a sigla do estado (Ex.: SP, RJ, SC)').required(REQUIRED_FIELD),
    password: Yup.string().test((value, schema) => {
        if (!value) {
            return true;
        }
        if ((value === null || value === void 0 ? void 0 : value.length) < 8) {
            return schema.createError({
                message: 'Deve conter no mínimo 8 caracteres'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/[a-z]+/))) {
            return schema.createError({
                message: 'Deve conter no mínimo uma letra minúscula'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/[A-Z]+/))) {
            return schema.createError({
                message: 'Deve conter no mínimo uma letra maiúscula'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/\d+/))) {
            return schema.createError({
                message: 'Deve conter um número'
            });
        }
        return true;
    }),
    password_confirmation: Yup.string().oneOf([Yup.ref('password')], 'As senhas devem ser iguais').when('password', ([value], schema) => {
        if (!!value) {
            return schema.required(REQUIRED_FIELD);
        }
        return schema;
    }),
    neighborhood: Yup.string().required(REQUIRED_FIELD),
});
exports.ForgotPasswordSchema = Yup.object({
    login: Yup.string().test({
        message: MUST_BE_VALID_CPF,
        test: (value) => {
            const isEmail = value === null || value === void 0 ? void 0 : value.match(/\D/ig);
            if (!isEmail) {
                const isCPFValid = CPF_TEST(value);
                if (isCPFValid) {
                    return true;
                }
                return false;
            }
            else {
                return true;
            }
        }
    }).test({
        message: MUST_BE_VALID_EMAIL,
        test: (value) => {
            const schema = Yup.string().email();
            const isEmail = value === null || value === void 0 ? void 0 : value.match(/\D/ig);
            if (isEmail) {
                const isEmailValid = schema.isValidSync(value);
                if (isEmailValid) {
                    return true;
                }
                return false;
            }
            else {
                return true;
            }
        }
    }).required(REQUIRED_FIELD),
});
exports.UpdatePasswordSchema = Yup.object({
    token: Yup.string().required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD),
    password_confirmation: Yup.string().oneOf([Yup.ref('password')], 'As senhas devem ser iguais').required(REQUIRED_FIELD),
});
exports.SignUpValidationSchema = Yup.object({
    name: Yup.string().required(REQUIRED_FIELD),
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    cpf: Yup.string().test({
        message: 'Deve ser um CPF válido',
        test: (value) => {
            const cpf = (value === null || value === void 0 ? void 0 : value.replace(/[^\d]+/g, '')) || '';
            if (cpf == '') {
                return false;
            }
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;
            let add = 0;
            for (let i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
            for (let i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        }
    }).required(REQUIRED_FIELD),
    invite_code: Yup.string().nullable().optional(),
    whatsapp: Yup.string().required(REQUIRED_FIELD),
    telegram: Yup.string(),
    cep: Yup.string().test({
        message: 'Deve ser um CEP válido',
        test: (value) => {
            const cep = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (cep === null || cep === void 0 ? void 0 : cep.length) === 8;
        }
    }).required(REQUIRED_FIELD),
    address: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    phone_number: Yup.string().required(REQUIRED_FIELD),
    complement: Yup.string().optional(),
    city: Yup.string().required(REQUIRED_FIELD),
    state: Yup.string().length(2, 'Use apenas a sigla do estado (Ex.: SP, RJ, SC)').required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD),
    password_confirmation: Yup.string().oneOf([Yup.ref('password')], 'As senhas devem ser iguais').required(REQUIRED_FIELD),
    neighborhood: Yup.string().required(REQUIRED_FIELD),
});
exports.SignInValidationSchema = Yup.object({
    login: Yup.string().test({
        message: MUST_BE_VALID_CPF,
        test: (value) => {
            const isEmail = value === null || value === void 0 ? void 0 : value.match(/\D/ig);
            if (!isEmail) {
                const isCPFValid = CPF_TEST(value);
                if (isCPFValid) {
                    return true;
                }
                return false;
            }
            else {
                return true;
            }
        }
    }).test({
        message: MUST_BE_VALID_EMAIL,
        test: (value) => {
            const schema = Yup.string().email();
            const isEmail = value === null || value === void 0 ? void 0 : value.match(/\D/ig);
            if (isEmail) {
                const isEmailValid = schema.isValidSync(value);
                if (isEmailValid) {
                    return true;
                }
                return false;
            }
            else {
                return true;
            }
        }
    }).required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD),
});
exports.CustomerSignInValidationSchema = Yup.object({
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD),
});
exports.UpdatePaymentValidationSchema = Yup.object({
    status: Yup
        .string()
        .oneOf(['PAID', 'CANCELLED'])
        .required(REQUIRED_FIELD),
});
exports.CreateOrderValidationSchema = Yup.object({
    flight_date: Yup.date().required(REQUIRED_FIELD),
    airline: Yup
        .string()
        .required(REQUIRED_FIELD),
    reservation_code: Yup
        .string()
        .required(REQUIRED_FIELD),
    amount: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    pax: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    fees: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    additional_cost: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .optional(),
    card_id: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    sell_price: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    author_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    pax_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    customer_id: Yup
        .string()
        .optional(),
    origin_airport_code: Yup
        .string()
        .length(3, 'Deve conter 3 caracteres')
        .required(REQUIRED_FIELD),
    description: Yup
        .string()
        .optional(),
    income_due_date: Yup
        .date()
        .optional()
        .nullable()
        .min(new Date(), 'A data deve ser maior que hoje')
});
exports.UpdateOrderValidationSchema = Yup.object({
    flight_date: Yup.date().required(REQUIRED_FIELD),
    airline: Yup
        .string()
        .required(REQUIRED_FIELD),
    customer_id: Yup
        .string()
        .optional(),
    reservation_code: Yup
        .string()
        .required(REQUIRED_FIELD),
    amount: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    pax: Yup
        .number()
        .min(1, 'O valor deve ser maior que zero')
        .required(REQUIRED_FIELD),
    fees: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    additional_cost: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .optional(),
    card_id: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    sell_price: Yup
        .number()
        .min(0, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    author_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    pax_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    origin_airport_code: Yup
        .string()
        .length(3, 'Deve conter 3 caracteres')
        .required(REQUIRED_FIELD),
    description: Yup
        .string()
        .optional(),
    income_due_date: Yup
        .date()
        .optional()
        .min(new Date(), 'A data deve ser maior que hoje')
});
exports.CreateCardValidationSchema = Yup.object({
    alias: Yup.string().required(REQUIRED_FIELD),
    brand: Yup
        .string()
        .oneOf(['AMEX', 'VISA', 'ELO', 'MASTERCARD'], 'Deve ser uma bandeira de cartão válida')
        .required(REQUIRED_FIELD),
    bank: Yup.string().required(REQUIRED_FIELD),
    number: Yup.string()
        .test({
        test: (value) => {
            const clean = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            if (!clean) {
                return false;
            }
            if ((clean.startsWith('34') || clean.startsWith('37')) && clean.length === 15) {
                return true;
            }
            if (clean.length === 16) {
                return true;
            }
            return false;
        },
        message: 'Deve ser um número de cartão válido',
    })
        .required(REQUIRED_FIELD),
    holder_name: Yup.string().required(REQUIRED_FIELD),
    cvv: Yup.string().length(3, 'Deve conter 3 dígitos').required(REQUIRED_FIELD),
    expiry: Yup.string().test({
        test: (value, context) => {
            if (!value || (value === null || value === void 0 ? void 0 : value.length) < 5) {
                return context.createError({
                    message: REQUIRED_FIELD,
                    path: context.path
                });
            }
            const [month, year] = value.split('/');
            if (Number(month) > 12 || Number(month) === 0) {
                return context.createError({
                    message: 'Deve ser um mês válido',
                    path: context.path
                });
            }
            if (Number(year) < Number((0, moment_1.default)().format('YY')) || (Number(year) === Number((0, moment_1.default)().format('YY') && Number(month) <= Number((0, moment_1.default)().format('MM'))))) {
                return context.createError({
                    message: 'O cartão não pode estar expirado',
                    path: context.path
                });
            }
            return true;
        },
    }),
});
exports.CreateBidValidationSchema = Yup.object({
    company: Yup
        .string()
        .required(REQUIRED_FIELD),
    miles: Yup.string().test({
        test: value => {
            if (Number(value) <= 0) {
                return false;
            }
            return true;
        },
        message: MUST_BE_GREATER_THAN_ZERO
    }).required(REQUIRED_FIELD),
    price: Yup.string().test({
        test: value => {
            if (Number(value) <= 0) {
                return false;
            }
            return true;
        },
        message: MUST_BE_GREATER_THAN_ZERO
    }).required(REQUIRED_FIELD),
    pax: Yup.string().test({
        test: value => {
            if (Number(value) < 0) {
                return false;
            }
            return true;
        },
        message: 'Deve ser um valor válido'
    }).nullable().required(REQUIRED_FIELD),
    account_id: Yup.string().required(REQUIRED_FIELD)
});
exports.DenyBidValidationSchema = Yup.object({
    reason: Yup
        .string()
        .required(REQUIRED_FIELD),
});
exports.CreateAccountValidationSchema = Yup.object({
    company: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_email: Yup
        .string()
        .email('Deve ser um e-mail válido')
        .required(REQUIRED_FIELD),
    holder_cpf: Yup.string().test({
        test: CPF_TEST,
        message: 'Deve ser um CPF válido',
    }).required(REQUIRED_FIELD),
    login: Yup.string().required(REQUIRED_FIELD),
    holder_phone_number: Yup.string().required(REQUIRED_FIELD),
    password: Yup.string().required(REQUIRED_FIELD),
    secondary_password: Yup.string().optional(),
    is_membership_active: Yup.boolean().required(REQUIRED_FIELD),
    holder_birthday: Yup.date().required(REQUIRED_FIELD),
    membership_number: Yup.string().required(REQUIRED_FIELD),
    accepts_custom_payment: Yup.boolean()
});
exports.UpdateAccountValidationSchema = Yup.object({
    holder_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_email: Yup
        .string()
        .email('Deve ser um e-mail válido')
        .required(REQUIRED_FIELD),
    holder_cpf: Yup.string().test({
        test: CPF_TEST,
        message: 'Deve ser um CPF válido',
    }).required(),
    login: Yup.string().required(REQUIRED_FIELD),
    holder_phone_number: Yup.string().required(REQUIRED_FIELD),
    password: Yup.string().optional(),
    secondary_password: Yup.string().optional(),
    is_membership_active: Yup.boolean().required(REQUIRED_FIELD),
    holder_birthday: Yup.date().required(REQUIRED_FIELD),
    membership_number: Yup.string().required(REQUIRED_FIELD),
});
exports.CreateSupportTicketValidationSchema = Yup.object({
    bid_id: Yup.string().optional(),
    message: Yup.string().required(REQUIRED_FIELD)
});
exports.CreateSupportTicketMessageValidationSchema = Yup.object({
    message: Yup.string().required(REQUIRED_FIELD)
});
exports.UpdateSupportTicketValidationSchema = Yup.object({
    status: Yup.string().oneOf(['OPEN', 'CLOSED']).required(REQUIRED_FIELD)
});
exports.UpdateProgramPriceSettingsValidationSchema = Yup.array().of(Yup.object({
    from: Yup.number().test({
        test: (value, context) => {
            // @ts-ignore
            const index = context.options.index;
            // @ts-ignore
            const actualPrices = context.options.context.prices;
            if (index === 0 && value !== 1) {
                return context.createError({
                    path: context.path,
                    message: 'Este campo deve ser 1'
                });
            }
            const lastItem = (0, lodash_1.get)(actualPrices, index - 1);
            const item = (0, lodash_1.get)(actualPrices, index);
            if (index > 0 && Number(item.from) !== Number(lastItem.to) + 1) {
                return context.createError({
                    path: context.path,
                    message: `Este campo deve ser ${lastItem.to ? Number(lastItem.to) + 1 : 'maior que o anterior'}`
                });
            }
            return true;
        }
    }).required(REQUIRED_FIELD),
    to: Yup.string().test({
        test: (value, context) => {
            // @ts-ignore
            const index = context.options.index;
            // @ts-ignore
            const actualPrices = context.options.context.prices;
            if (!value && index !== actualPrices.length - 1) {
                return context.createError({
                    path: context.path,
                    message: REQUIRED_FIELD
                });
            }
            return true;
        }
    }).nullable(),
    price: Yup.number().required(REQUIRED_FIELD)
}));
exports.CreateLeadBidValidationSchema = Yup.object({
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    company: Yup.string().required(REQUIRED_FIELD),
    amount: Yup.number().required(REQUIRED_FIELD),
    reCaptchaToken: Yup.string().required(REQUIRED_FIELD),
    origin: Yup.string().optional()
});
